export const patientConstants = {
  PATIENT_RETRIEVE_CLEAR: 'PATIENT_RETRIEVE_CLEAR',
  PATIENT_RETRIEVE_REQUEST: 'PATIENT_RETRIEVE_REQUEST',
  PATIENT_RETRIEVE_SUCCESS: 'PATIENT_RETRIEVE_SUCCESS',
  PATIENT_RETRIEVE_FAILURE: 'PATIENT_RETRIEVE_FAILURE',

  PATIENT_MSGS_REQUEST: 'PATIENT_MSGS_REQUEST',
  PATIENT_MSGS_SUCCESS: 'PATIENT_MSGS_SUCCESS',
  PATIENT_MSGS_FAILURE: 'PATIENT_MSGS_FAILURE'
}